import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Dialog } from '../ui';

const PREVIEW_FIELDS = 3;

/** A collection with several item types: which one is the new item? */
function ItemTypeSelectionModal({ inventory, onSelectItemType, onClose }) {
  const { t } = useTranslation();
  const types = inventory.item_types || [];
  const [selectedId, setSelectedId] = useState(
    inventory.default_item_type ? inventory.default_item_type.id : (types.length > 0 ? types[0].id : null)
  );
  const selected = types.find(type => String(type.id) === String(selectedId));

  const submit = (e) => {
    e.preventDefault();
    if (selected) onSelectItemType(selected);
  };

  return (
    <Dialog
      open
      onClose={onClose}
      title={t('typeSelection.title')}
      description={t('typeSelection.intro')}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose}>{t('common.cancel')}</Button>
          <Button type="submit" form="type-selection" disabled={!selected}>{t('typeSelection.continue', { name: selected?.name || '' })}</Button>
        </>
      )}
    >
      <form id="type-selection" onSubmit={submit}>
        <fieldset className="choice-list">
          <legend className="visually-hidden">{t('itemForm.itemType')}</legend>
          <ul className="choice-list__rows">
            {types.map(itemType => {
              const fields = itemType.fields || [];
              const isSelected = String(selectedId) === String(itemType.id);
              return (
                <li key={itemType.id} className={`choice-row${isSelected ? ' is-selected' : ''}`}>
                  <input type="radio" name="itemType" id={`itemtype-${itemType.id}`} value={itemType.id}
                         checked={isSelected} onChange={() => setSelectedId(itemType.id)} />
                  <label htmlFor={`itemtype-${itemType.id}`} className="choice-row__text">
                    <span className="choice-row__title">
                      {itemType.name}{' '}
                      {itemType.is_default && <Badge tone="accent">{t('collections.default')}</Badge>}
                    </span>
                    {itemType.description && <span className="choice-row__hint">{itemType.description}</span>}
                    <span className="choice-row__hint">
                      {t('collections.fieldCount', { count: fields.length })}
                      {fields.length > 0 && ` · ${fields.slice(0, PREVIEW_FIELDS).map(f => f.name).join(', ')}`}
                      {fields.length > PREVIEW_FIELDS && ` ${t('typeSelection.more', { count: fields.length - PREVIEW_FIELDS })}`}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
        </fieldset>
      </form>
    </Dialog>
  );
}

export default ItemTypeSelectionModal;
